import pages from '../screens/all-pages';
import IndexScene from '../screens/home/index.jsx';
export const ROUTE_LOGIN = 'https://central.zetta-system.com';
export const ROUTE_LOGIN_MANUAL = '/account/login';
export const ROUTE_HANDLE = '/account/handle';

export const KEY_ROUTE_MAIN = '@ROUTES/ROUTE_MAIN';
export const KEY_ROUTE_HOME = '@ROUTES/ROUTE_HOME';
export const KEY_ROUTE_SCAN_INCENTIVE = '@ROUTES/ROUTE_SCAN_INCENTIVE';
export const KEY_ROUTE_SCAN_HISTORY = '@ROUTES/ROUTE_SCAN_HISTORY';
export const KEY_ROUTE_LOGIN_EMPLOYEE = '@ROUTES/ROUTE_LOGIN_EMPLOYEE';
export const KEY_ROUTE_LOGOUT_EMPLOYEE = '@ROUTES/ROUTE_LOGOUT_EMPLOYEE';

export const ROUTES_PATH = {
  ROUTE_MAIN: {
    KEY: KEY_ROUTE_MAIN,
    PATH: '/',
    LABEL: 'หน้าหลัก',
    COMPONENT: IndexScene,
  },
  ROUTE_HOME: {
    KEY: KEY_ROUTE_HOME,
    PATH: '/home',
    LABEL: 'หน้าหลัก',
  },
  ROUTE_SCAN_INCENTIVE: {
    KEY: KEY_ROUTE_SCAN_INCENTIVE,
    PATH: '/scan-incentive',
    LABEL: 'Barcode Scan',
    COMPONENT: pages.ScanIncentive,
  },
  ROUTE_SCAN_HISTORY: {
    KEY: KEY_ROUTE_SCAN_HISTORY,
    PATH: '/scan-history',
    LABEL: 'ประวัติการสแกน',
    COMPONENT: pages.ScanHistory,
  },
  ROUTE_LOGIN_EMPLOYEE: {
    KEY: KEY_ROUTE_LOGIN_EMPLOYEE,
    PATH: '/login-employee',
    LABEL: 'เข้าสู่ระบบ',
    COMPONENT: pages.LoginEmployee,
  },
  ROUTE_LOGOUT_EMPLOYEE: {
    KEY: KEY_ROUTE_LOGOUT_EMPLOYEE,
    PATH: '/logout-employee',
    LABEL: 'Logout',
    COMPONENT: pages.LogoutEmployee,
  },
};

function getKeyLowerCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export const ROUTES_MENU = [getKeyLowerCase(ROUTES_PATH.ROUTE_LOGIN_EMPLOYEE)];

export const ROUTES_MENU_LOGGED_IN = [
  getKeyLowerCase(ROUTES_PATH.ROUTE_LOGOUT_EMPLOYEE),
  getKeyLowerCase(ROUTES_PATH.ROUTE_SCAN_INCENTIVE),
  getKeyLowerCase(ROUTES_PATH.ROUTE_SCAN_HISTORY),
];
